import { useState } from "react";
import { faqs } from "@/mocks/comics";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-3xl px-4 md:px-6">
        <div className="text-center">
          <p className="text-sm font-bold text-primary-600">常见问题</p>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">
            关于追更，你可能想知道
          </h2>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((f, idx) => {
            const isOpen = openIdx === idx;
            return (
              <div
                key={f.question}
                className="overflow-hidden rounded-lg border border-background-200/70 bg-background-50"
              >
                <button
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                  onClick={() => setOpenIdx(isOpen ? -1 : idx)}
                  aria-expanded={isOpen}
                >
                  <h3 className="text-sm font-bold text-foreground-950 md:text-base">
                    {f.question}
                  </h3>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-700 transition-transform ${
                      isOpen ? "rotate-45 bg-primary-100 text-primary-700" : ""
                    }`}
                  >
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                      {f.answer}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}